import { EDIS_HOLDINGS_DATA, EDIS_HOLDINGS_ERROR, EDIS_HOLDINGS_HIDE_ERROR, EDIS_HOLDINGS_START_LOADER, EDIS_HOLDINGS_STOP_LOADER, } from "../interface/Holdings";
const initialState = {
    data: {},
    holdingLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const edisHoldingReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIS_HOLDINGS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EDIS_HOLDINGS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EDIS_HOLDINGS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case EDIS_HOLDINGS_START_LOADER:
            return Object.assign(Object.assign({}, state), { holdingLoader: true });
        case EDIS_HOLDINGS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { holdingLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default edisHoldingReducer;
